import { render } from "./PricingCards.vue?vue&type=template&id=f3aa2f7c&scoped=true"
import script from "./PricingCards.vue?vue&type=script&lang=js"
export * from "./PricingCards.vue?vue&type=script&lang=js"

import "./PricingCards.vue?vue&type=style&index=0&id=f3aa2f7c&scoped=true&lang=css"
import "./PricingCards.vue?vue&type=style&index=1&id=f3aa2f7c&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3aa2f7c"]])

export default __exports__